import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';

@Component({
  selector: 'app-view-animal-vaccine',
  templateUrl: './view-animal-vaccine.component.html',
  styleUrls: ['./view-animal-vaccine.component.css']
})
export class ViewAnimalVaccineComponent implements OnInit {
  getanimalvaccineviewApi:any;
  testdate:any;
  testdate1:any;
  expiredate:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit() {
    let VaccineId = sessionStorage.getItem('vaccineId');
    this.getanimalvaccineviewApi= "/animal_management/vaccine/"+VaccineId;
    (await this.commonService.getApi(this.getanimalvaccineviewApi)).subscribe(
      res => { 
        console.log(res.data);
        var dateexpire=res.data.tnam_vac_expiry_date;
        this.expiredate = dateexpire.split('T');
        var date=res.data.tnam_vac_date_of_first_vaccine;
         this.testdate = date.split('T');
        //  var date1=res.data.tnam_vac_date_of_second_vaccine;
        //  this.testdate1 = date1.split('T');
         $("#batchno").text(res.data.tnam_vac_batch_number);
         $("#remark").text(res.data.tnam_vac_date_of_second_vaccine);
        $("#VaccineName").text(res.data.tnam_vac_vaccine_name);
    //   $("#DiscoveryDate").text(res.data.tnam_dis_date_of_discovery),
    $("#dosevalue").text(res.data.tnam_vac_dose_value+' '+res.data.tnam_vac_units)
      // $("#Description").text(res.data.tnam_dis_disease_description)
      })
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
